import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LocationDetails from "./LocationDetails";

class LocationDetailsModal extends Component {
  render() {
    const {
      permissions,
      showLocationDetailsModal,
      toggleLocationDetailsModal,
      projectId,
      locationId,
      editLocation,
      deleteLocation,
    } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleLocationDetailsModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <Modal
        isOpen={showLocationDetailsModal}
        toggle={toggleLocationDetailsModal}
        className={this.props.className}
        size={"lg"}
        fade={false}
      >
        <ModalHeader
          toggle={toggleLocationDetailsModal}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
          Location Details
        </ModalHeader>
        <ModalBody>
          <LocationDetails
            permissions={permissions}
            projectId={projectId}
            locationId={locationId}
            handleClick_edit={editLocation}
            deleteContractor={deleteLocation}
          />
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group float-right mb-0">
            <button
              type="button"
              name="closeLocationDetails"
              id="closeLocationDetails"
              className="btn btn-secondary"
              onClick={toggleLocationDetailsModal}
            >
              Close
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default LocationDetailsModal;
